const SIGN_OUT_GATE_STORAGE_KEY = 'bennie-signing-out';
const SIGN_OUT_GATE_ALLOWED = '1';

export function setSigningOutGate() {
  sessionStorage.setItem(SIGN_OUT_GATE_STORAGE_KEY, SIGN_OUT_GATE_ALLOWED);
}

export function clearSigningOutGate() {
  sessionStorage.removeItem(SIGN_OUT_GATE_STORAGE_KEY);
}

export function isSigningOut() {
  return sessionStorage.getItem(SIGN_OUT_GATE_STORAGE_KEY) === SIGN_OUT_GATE_ALLOWED;
}
